import { ShopifyCart } from "types";
import { z } from "zod";
import { formatZodError } from "utils/zod-error";
import { fetchSymbol } from "../fetch/fetch-helper";

const endpoint = '/cart/update.js';

export const cartUpdateParamsSchema = z.object({
  updates: z.union([z.record(z.number()), z.array(z.number())]).optional(),
  note: z.string().optional(),
  attributes: z.record(z.any()).optional(),
});

export type CartUpdateParams = z.infer<typeof cartUpdateParamsSchema>;

export async function update(params: CartUpdateParams, noIntercept?: boolean): Promise<ShopifyCart> {
  const parseResult = cartUpdateParamsSchema.safeParse(params);
  if (!parseResult.success) throw new TypeError(`Couldn't update cart due to invalid params: ${formatZodError(parseResult.error)}`);
  const res = await window[fetchSymbol].postJSON<ShopifyCart>(endpoint, params, noIntercept);
  return res;
}
